import classnames from "classnames";
import ControlButton from "components/ControlButton";
import React from "react";
import PropTypes from "prop-types";
import styles from "./CaptionButton.css";

export default function CaptionButton(props) {
  if (props.textTrack) {
    const language = props.textTrack.srclang;
    const languageLabel = props.textTrack.label;
    const menuButtons = [];
    let settingsButton;

    if (!props.isChapterCoverShowing) {
      settingsButton = (
        <ControlButton
          ariaLabel="Caption settings"
          className={styles.settingsButton}
          key="settings-btn"
          onClick={() => props.showTextTrackSettings()}
          text=""
        />
      );
    }

    const buttonClassName = classnames(styles.languageButton, {
      [styles.selectedLanguage]: !!props.isActive,
    });

    menuButtons.push(
      <ControlButton
        ariaLabel={`Caption ${languageLabel}`}
        className={buttonClassName}
        key={language}
        onClick={() => props.setTextTrackLanguage(language)}
        text="ON"
      />,
    );

    let menuButtonsContainer = menuButtons;
    // If more than 2 language buttons,
    // they are wrapped and become scrollable.
    if (menuButtons.length > 3) {
      menuButtonsContainer = (
        <div className={styles.menuButtonsContainer}>{menuButtons}</div>
      );
    }

    const rootClassName = classnames(styles.root, {
      [styles.hideCaptions]: !props.textTrack,
    });

    const dropUpMenuClassName = classnames(styles.dropup, {
      [styles.showDropup]: props.showingMenu,
    });

    const captionButtonClassName = classnames({
      [styles.selectedLanguage]: props.isActive,
    });

    return (
      <div className={rootClassName} lang={language}>
        <div className={dropUpMenuClassName}>
          {settingsButton}
          {menuButtonsContainer}
          <ControlButton
            ariaLabel="Captions off"
            className={classnames({
              [styles.selectedLanguage]: !props.isActive,
            })}
            key="off"
            onClick={() => {
              const playerOptions = {
                ...props.playerOptions,
                showClosedCaptions: false,
              };
              // viewing user requested off, so override playerOption
              props.setPlayerOptions(playerOptions);
              props.setTextTrackLanguage("");
            }}
            text="Off"
          />
        </div>
        <ControlButton
          ariaLabel="Show captions menu"
          border={props.border}
          className={captionButtonClassName}
          key="root-button"
          onClick={() => props.setShowMenu(!props.showingMenu)}
        >
          <span className={styles.captionButton} />
        </ControlButton>
      </div>
    );
  }
  return null;
}

CaptionButton.propTypes = {
  border: PropTypes.bool,
  isActive: PropTypes.bool.isRequired,
  isChapterCoverShowing: PropTypes.bool.isRequired,
  playerOptions: PropTypes.object.isRequired,
  setPlayerOptions: PropTypes.func.isRequired,
  setShowMenu: PropTypes.func.isRequired,
  setTextTrackLanguage: PropTypes.func.isRequired,
  showingMenu: PropTypes.bool.isRequired,
  showTextTrackSettings: PropTypes.func.isRequired,
  textTrack: PropTypes.object.isRequired,
};

CaptionButton.defaultProps = {
  border: true,
};
